/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module ApplicationInsightsPolicyModule
 */

import { IApplicationInsightsParams } from 'generated-types';
import { MessageItem } from 'ajs/modules/data-model/factories/message-item.factory';

export class ApplicationInsightsParamsConfigItem extends MessageItem<IApplicationInsightsParams> {
    constructor(args = {}) {
        const extendedArgs = {
            objectType: 'ApplicationInsightsParams',
            ...args,
        };

        super(extendedArgs);
    }

    // eslint-disable-next-line class-methods-use-this
    protected override requiredFields(): string[] {
        return [
            'learn_from_bots',
        ];
    }
}
